import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-view-image',
  templateUrl: './view-image.component.html',
  styleUrls: ['./view-image.component.scss']
})
export class ViewImageComponent implements OnInit {
  
  docType: boolean;
  @Input() docs: any;
  showNavigationArrows = true;
  showNavigationIndicators = true;
  fa: any;

  constructor(
    private activeModal: NgbActiveModal,
    config: NgbCarouselConfig) {
      config.showNavigationArrows = true;
      config.showNavigationIndicators = true;
    }
  
  ngOnInit(): void {
    const vm = this;
    vm.fa = null;
  }

  getType(data: string) {
    if (data.includes('application/pdf')) {
      return true;
    } else {
      return false;
    }
  }

  onClose() {
    const vm = this;
    vm.activeModal.close();
  }

  downloadImage(doc: any) {
     const linkSource = doc;
     const downloadLink = document.createElement('a');
     const fileName = 'IKFHF';
     downloadLink.href = linkSource;
     downloadLink.download = fileName;
     downloadLink.click();
     document.body.removeChild(downloadLink);
   }

}
